import React from "react";
import { Link } from "react-router-dom";
import { useRoleVerify } from "Common/RoleVerify";

const ChackIBtn = ({ url }) => {

  if (!useRoleVerify("room-check-in", ["can_access"])) return null;

  return (
    <Link
      to={`/admin/room-check-in/${url}`}
      className="btn btn-success btn-sm border rounded-2 me-1"
      aria-label="View"
      title="check in"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="svg-stroke"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M13 12v.01" />
        <path d="M3 21h18" />
        <path d="M5 21v-16a2 2 0 0 1 2 -2h6m4 10.5v7.5" />
        <path d="M21 7h-7m3 -3l-3 3l3 3" />
      </svg>
    </Link>
  );
};

export default ChackIBtn;
